// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   firebase : {
//     apiKey: "AIzaSyA39uo6ohwCxP8OJc1jfdGITuLDdKCETOE",
//     authDomain: "demokrati-a63f7.firebaseapp.com",
//     databaseURL: "https://demokrati-a63f7.firebaseio.com",
//     projectId: "demokrati-a63f7",
//     storageBucket: "demokrati-a63f7.appspot.com",
//     messagingSenderId: "27798996976",
//     appId: "1:27798996976:web:6448efd1ad06d9b332bf35",
//     measurementId: "G-GCQYG966Y7"
//   }
// };

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyBh8WvzqbIlm2oW0DjtwptyIKb2XUXb8OY",
    authDomain: "demokrati-5d660.firebaseapp.com",
    databaseURL: "https://demokrati-5d660.firebaseio.com",
    projectId: "demokrati-5d660",
    storageBucket: "demokrati-5d660.appspot.com",
    messagingSenderId: "380992125300",
    appId: "1:380992125300:web:a8f6b8db7423ed455cd421",
    measurementId: "G-8983YVPSLK"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
